import React from "react";
import PropTypes from "prop-types";
import { Card } from "antd";

const PatentAnalytics = props => {
  return (
    <Card bodyStyle={{ textAlign: "center", minHeight: 400 }}>
      {React.cloneElement(props.children, {
        key: props.location.pathname + props.location.search,
        filter: props.filter
      })}
    </Card>
  );
};
PatentAnalytics.propTypes = {
  filter: PropTypes.object
};

export default PatentAnalytics;
